import {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {selectOpenedFlyoutIds} from 'coreStore/data/ui/index';
import {RootState} from 'coreStore/types';

export const useOpenedFlyouts = (flyoutId?: string) => {
	const openedFlyouts = useSelector<RootState, string[]>((state) => selectOpenedFlyoutIds(state));

	const isOpen = useMemo(() => openedFlyouts.includes(flyoutId), [flyoutId, openedFlyouts]);
	const isAnyFlyoutOpened = useMemo(() => openedFlyouts.length > 0, [openedFlyouts]);

	return {openedFlyoutIds: openedFlyouts, isOpen, isAnyFlyoutOpened};
};
